import { Outlet } from 'react-router-dom';

/**
 * Instructor Studio shell. The section navigation lives in the app sidebar
 * (AppLayout) — each sub-screen renders its own heading, so the shell is just
 * the nested-route outlet.
 */
export function Studio() {
  return <Outlet />;
}
